
import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";

interface DataTableProps<TData, TValue> {
  columns: {
    id?: string;
    accessorKey?: string;
    header: string;
    cell?: ({ row }: { row: any }) => React.ReactNode;
  }[];
  data: TData[];
}

export function DataTable<TData, TValue>({
  columns,
  data,
}: DataTableProps<TData, TValue>) {
  return (
    <div className="w-full">
      <div className="overflow-x-auto scrollbar-hide -mx-4 sm:mx-0 rounded-md border border-border/60">
        <Table>
          <TableHeader>
            <TableRow>
              {columns.map((column) => (
                <TableHead key={column.id || column.accessorKey} className="whitespace-nowrap">
                  {column.header}
                </TableHead>
              ))}
            </TableRow>
          </TableHeader>
          <TableBody>
            {data.length === 0 ? (
              <TableRow>
                <TableCell colSpan={columns.length} className="h-24 text-center">
                  No results found.
                </TableCell>
              </TableRow>
            ) : (
              data.map((row: any, i) => (
                <TableRow key={i}>
                  {columns.map((column) => (
                    <TableCell key={column.id || column.accessorKey} className="whitespace-nowrap">
                      {column.cell
                        ? column.cell({ row: { 
                            original: row, 
                            getValue: (key: string) => row[key] 
                          }})
                        : column.accessorKey
                        ? row[column.accessorKey]
                        : null}
                    </TableCell>
                  ))}
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
